var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { VoucherTypeIds } from '@debbie/common/dist/economy/vouchers';
import { VoucherApplicationType, } from '@debbie/common/dist/voucher-applications';
import { c } from '@debbie/cortex/dist';
import * as voucherApplications from '@debbie/cortex/dist/api/voucher-applications';
import { selectAuthToken } from '@debbie/cortex/dist/auth/selectors';
import { Size } from '../../design-system';
import { toPercent } from '../../utils';
import Checkbox from '../Checkbox';
import Money from '../Money';
const VoucherApplication = (props) => {
    const lang = useSelector((s) => s.lang);
    const application = props.voucherApplication.application;
    const authToken = useSelector(selectAuthToken);
    const toggleActive = () => __awaiter(void 0, void 0, void 0, function* () {
        if (authToken) {
            yield voucherApplications.update(props.voucherApplication.tenantId, props.voucherApplication.id, {
                enabled: !props.voucherApplication.enabled,
            });
        }
        yield c.voucherApplications.getVoucherApplications(props.voucherApplication.tenantId);
    });
    const interestText = (options) => (options.fromDateProperty
        ? `${options.days} ${lang.economy.interestStartDays} fra ${options.fromDateProperty} ellers `
        : '') +
        `${options.days} ${lang.economy.interestStartDays} ${lang.interestFromLabels[options.from]}`;
    return (React.createElement(Wrapper, { inactive: props.inactive },
        React.createElement(Content, null,
            React.createElement(When, null,
                lang.voucherApplications.textSelector1,
                React.createElement(Highlight, null, lang.voucherApplicationTypeLabels[application.type]),
                ' ',
                React.createElement(Highlight, null, application.type === VoucherApplicationType.VoucherType
                    ? lang.economyVoucherTypeLabels[application.applyToVoucherType]
                    : application.type === VoucherApplicationType.VoucherCategory
                        ? lang.economyCategories[application.applyToVoucherCategory]
                        : null),
                lang.voucherApplications.textSelector2,
                React.createElement(Highlight, null, lang.voucherApplicationTargetLabels[application.target]),
                lang.voucherApplications.textSelector3),
            React.createElement(What, null,
                React.createElement("p", null,
                    lang.economyVoucherTypeLabels[application.voucherType],
                    ' - ',
                    application.voucherType === VoucherTypeIds.GLPROCESSINTEREST ||
                        application.voucherType === VoucherTypeIds.PROCESSINTEREST ||
                        application.voucherType === VoucherTypeIds.YEARLYINTEREST ||
                        application.voucherType === VoucherTypeIds.FIXEDINTEREST
                        ? interestText(application.voucherOptions)
                        : null,
                    application.voucherType === VoucherTypeIds.YEARLYINTEREST
                        ? `, ${toPercent(application.voucherOptions.interestRate)}%`
                        : null,
                    ![
                        VoucherTypeIds.FIXEDINTEREST,
                        VoucherTypeIds.YEARLYINTEREST,
                        VoucherTypeIds.PROCESSINTEREST,
                        VoucherTypeIds.GLPROCESSINTEREST,
                    ].includes(application.voucherType) ? (React.createElement(Money, { amount: application.voucherOptions.amount })) : null))),
        React.createElement(Checkbox, { checked: props.voucherApplication.enabled, size: Size.Small, onChange: toggleActive })));
};
const Wrapper = styled.div `
  margin-bottom: 20px;
  border-bottom: 1px solid lightgray;

  :last-child {
    border-bottom: none;
    margin-bottom: 0px;
  }

  display: flex;
  justify-content: space-between;
  align-items: center;

  opacity: ${(props) => (props.inactive ? '0.2' : '1')};
  /*filter: saturate(${(props) => (props.inactive ? '0' : '1')});*/
`;
const Highlight = styled.span `
  font-weight: bold;
`;
const When = styled.div ``;
const What = styled.div ``;
const Content = styled.div `
  margin-right: 20px;
`;
export default VoucherApplication;
//# sourceMappingURL=VoucherApplication.js.map